export default __webpack_public_path__ + "static/media/notFound.4abd36fd.svg";